import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import { NumberInput } from '@components/NumberPicker/NumberPicker.style';
import TextInputBox from '@components/TextInputBox/TextInputBox';
import TextArea from '@components/Textarea/Textarea';

/**
 * VITALL-styled text editor component for the routine form
 */
const TextEditor = ({ ...props }: AppointmentForm.TextEditorProps) => {
  const { type, value, onValueChange } = props;
  switch (type) {
    case 'numberEditor':
      return (
        <NumberInput
          onChange={(ev) => {
            onValueChange(ev.target.value);
          }}
          style={{ padding: 0, width: '50px', margin: 'auto 0' }}
          type="number"
          value={value}
        />
      );
    case 'multilineTextEditor':
      return (
        <TextArea
          onChange={(ev) => {
            onValueChange(ev.target.value);
          }}
          value={value ? value.toString() : ''}
        />
      );
    case 'ordinaryTextEditor':
    case 'titleTextEditor':
    default:
      return (
        <TextInputBox
          onChange={(ev) => {
            onValueChange(ev.target.value);
          }}
          value={value ? value.toString() : ''}
        />
      );
  }
};

export default TextEditor;
